import type { Period } from "@/services/searchPerformanceService";
import { cn } from "@/lib/utils";

export interface PeriodSelectorProps {
	value: Period;
	onChange: (p: Period) => void;
}

const OPTIONS: { value: Period; label: string }[] = [
	{ value: "7d", label: "7 days" },
	{ value: "28d", label: "28 days" },
	{ value: "90d", label: "90 days" },
];

export function PeriodSelector({ value, onChange }: PeriodSelectorProps) {
	return (
		<div
			role="radiogroup"
			aria-label="Date range"
			className="inline-flex rounded-lg border bg-card p-0.5"
		>
			{OPTIONS.map((opt) => (
				<button
					key={opt.value}
					role="radio"
					aria-checked={value === opt.value}
					onClick={() => onChange(opt.value)}
					className={cn(
						"rounded-md px-3 py-1.5 text-dash-subtitle font-medium transition-colors",
						value === opt.value
							? "bg-coral text-primary-foreground"
							: "text-muted-foreground hover:bg-muted"
					)}
				>
					{opt.label}
				</button>
			))}
		</div>
	);
}
